/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureCloudAccountSummaryBatchResponse {
    getFixupPrototypeFunction() { return TagPostureCloudAccountSummaryBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TagPostureCloudAccountSummaryBatchResponse>): TagPostureCloudAccountSummaryBatchResponse {
        let obj = Object.assign(new TagPostureCloudAccountSummaryBatchResponse(), model);
        TagPostureCloudAccountSummaryBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureCloudAccountSummaryBatchResponse>): TagPostureCloudAccountSummaryBatchResponse {
        if (!model) return null;
        return TagPostureCloudAccountSummaryBatchResponse.newInstance(<TagPostureCloudAccountSummaryBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureCloudAccountSummaryBatchResponse) {
        if (!obj) return;

        models.TagPostureCloudAccountSummaryBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureCloudAccountSummaryBatchResponse): boolean {
        Object.setPrototypeOf(obj, TagPostureCloudAccountSummaryBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagPostureCloudAccountSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagPostureCloudAccountSummary; };

}
